"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setApplicationConfiguration = void 0;
const appConfiguration = {
    homePage: '/',
    pages: [],
    userMenuItems: []
};
const setApplicationConfiguration = (config) => Object.keys(config).forEach((configKey) => (appConfiguration[configKey] = config[configKey]));
exports.setApplicationConfiguration = setApplicationConfiguration;
exports.default = appConfiguration;
//# sourceMappingURL=application.config.js.map